import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.css'],
    standalone: false
})
export class ConfirmModalComponent implements OnDestroy {
  @ViewChild('content') content: ElementRef;

  public confirmationResult: Subject<boolean>;
  public modalTitle: string;
  public modalDescription: string;
  constructor(private _modalService: NgbModal) { }

  open(title: string, description: string) {
    this.confirmationResult = new Subject();
    this.modalDescription = description;
    this.modalTitle = title;
    this._modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.confirmationResult.next(result);
    }, (reason) => {
      this.confirmationResult.next(null);
    });
  }

  ngOnDestroy(): void {
    if (this.confirmationResult) {
      this.confirmationResult.unsubscribe();
    }
  }

}
